export interface CellValidationResult {
  Value?: any;
  IsValid?: ValidationResult;
  ErrorCode?: string;
}

export enum ValidationResult {
  None = 0,
  Ok = 1,
  Warning = 2,
  Error = 3
}
